import { useState } from 'react';

import { Square, Check } from 'lucide-react';
import { CircleIcon } from '../icons/CircleIcon';
import { CircleIconFilled } from '../icons/CircleIconFilled';

const SelectionList = ({ options, onSelectionChange, exclusive = false }) => {
  const [selectedOptions, setSelectedOptions] = useState({});

  const toggleOption = (option) => {
    setSelectedOptions((prev) => {
      const { [option]: _, ...newSelection } = exclusive ? {} : prev;
      if (!prev[option]) {
        newSelection[option] = true;
      }

      if (onSelectionChange) {
        onSelectionChange(newSelection);
      }
      console.log(newSelection);
      console.log(prev[option]);
      return newSelection;
    });
  };

  const selectionsJSX = options.map((option) => {
    return (
      <div className="flex items-center mb-1">
        <div className="w-6 h-6 relative flex items-center">
          {exclusive ? (
            <>
              {selectedOptions[option] ? (
                <CircleIconFilled
                  className="w-5 h-5 hover:cursor-pointer"
                  onClick={() => toggleOption(option)}
                />
              ) : (
                <CircleIcon
                  className="w-5 h-5 hover:cursor-pointer"
                  onClick={() => toggleOption(option)}
                />
              )}
            </>
          ) : (
            <>
              <Square className="hover:cursor-pointer" onClick={() => toggleOption(option)} />
              {selectedOptions[option] && (
                <Check
                  className={`absolute w-4 h-4 stroke-[3px] top-1 left-1 pointer-events-none`}
                />
              )}
            </>
          )}
        </div>

        <span className="ml-2 select-none">{option}</span>
      </div>
    );
  });

  return <div className="flex flex-col">{selectionsJSX}</div>;
};

export { SelectionList };
